import { StaticImage as Image } from 'gatsby-plugin-image'
import styled from 'styled-components'
import { Media } from '../theme'

export const Billboard = styled(Image)`
  z-index: -1;
  position: absolute !important;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  ${Media.phone`
    max-width: 100vw;
 `}
`
